import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

const DiagnosisTests = ({ data }) => {
  const { title, slider, type } = data;
  return (
    <div className="flex flex-wrap">
      <h2
        className={`mb-6 w-full basis-full px-4 text-center font-canossaBd text-4xl text-secondary`}
      >
        {title}
      </h2>
      <div className="w-full basis-full">
        {type === "type1" ? (
          <div className="flex flex-wrap">
            {slider?.map((slide, index) => {
              const imageData = getImage(
                slide?.image?.localFile?.childImageSharp?.gatsbyImageData
              );
              return (
                <div
                  className={`group mb-4 w-full basis-full px-4 lg:w-1/4 lg:basis-1/4 ${
                    index % 2 !== 0 && "mt-16"
                  }`}
                  key={index}
                >
                  <div className="image-face relative group-hover:after:hidden">
                    <GatsbyImage image={imageData} alt="" />
                    {slide.button && (
                      <a href={slide.button.url} target={slide.button.target}>
                        <svg
                          width="54"
                          height="54"
                          viewBox="0 0 54 54"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="absolute top-1/2 left-1/2 hidden -translate-x-1/2 -translate-y-1/2 group-hover:block"
                        >
                          <circle
                            cx="27"
                            cy="27"
                            r="27"
                            fill="white"
                            fillOpacity="0.9"
                          />
                          <path
                            d="M17.3457 27.4254H37.5057"
                            stroke="#A91E41"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M29.2588 19.1782L37.5061 27.4254L29.2588 35.6727"
                            stroke="#A91E41"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                    )}
                  </div>
                  <h4 className="mt-4 mb-4 font-futuraMd text-3xl text-bannergrey group-hover:text-secondary">
                    {slide.title}
                  </h4>
                  <div
                    className="text-base text-bannergrey"
                    dangerouslySetInnerHTML={{ __html: slide.content }}
                  ></div>
                </div>
              );
            })}
          </div>
        ) : type === "type2" || type === "type3" ? (
          <Swiper
            spaceBetween={0}
            slidesPerView={1}
            className="navigationOuter"
            autoplay={{ delay: 7500, disableOnInteraction: false }}
            modules={[Navigation, Autoplay]}
            navigation={true}
            breakpoints={{
              1024: {
                slidesPerView: type === "type2" ? 3 : 2,
                spaceBetween: 30,
              },
            }}
          >
            {slider?.map((slide, index) => {
              const imageData = getImage(
                slide?.image?.localFile?.childImageSharp?.gatsbyImageData
              );
              return (
                <SwiperSlide key={index}>
                  <div className="h-100 group rounded-3xl border-x border-b border-solid border-secondary">
                    <div className="relative">
                      <GatsbyImage image={imageData} alt="" />
                    </div>
                    <div className="rounded-b-3xl py-4 text-center group-hover:bg-secondary">
                      <h4 className="mb-4 px-4 text-left font-futuraMd text-3xl text-secondary group-hover:text-white">
                        {slide.title}
                      </h4>
                      <div
                        className="px-4 text-left text-base text-bannergrey group-hover:text-white"
                        dangerouslySetInnerHTML={{ __html: slide.content }}
                      ></div>
                      {slide.button && (
                        <a
                          href={slide.button.url}
                          target={slide.button.target}
                          className="mt-4 inline-block rounded-xl px-10 py-2 font-futuraMd uppercase text-secondary group-hover:bg-white"
                        >
                          {slide.button.title}
                        </a>
                      )}
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          type === "type4" && (
            <Swiper
              spaceBetween={0}
              slidesPerView={1}
              className="navigationOuter"
              autoplay={{ delay: 7500, disableOnInteraction: false }}
              modules={[Navigation]}
              navigation={true}
            >
              {slider?.map((slide, index) => {
                const imageData = getImage(
                  slide?.image?.localFile?.childImageSharp?.gatsbyImageData
                );
                return (
                  <SwiperSlide key={index}>
                    <div className="relative">
                      <GatsbyImage image={imageData} alt="" />
                    </div>
                    <div className="absolute top-0 left-0 z-10 flex h-full w-full flex-wrap items-center p-2 xl:p-8">
                      <div className="w-full basis-full lg:w-1/2 lg:basis-1/2">
                        <h4 className="mb-2 text-left font-canossaBd text-lg text-white xl:mb-4 xl:text-7xl">
                          {slide.title}
                        </h4>
                        <div
                          className="text-left font-canossa text-base text-white xl:text-3xl"
                          dangerouslySetInnerHTML={{ __html: slide.content }}
                        ></div>
                        {slide.button && (
                          <a
                            href={slide.button.url}
                            target={slide.button.target}
                            className="mt-2 inline-block rounded-xl bg-white px-10 py-2 font-futuraMd uppercase text-black xl:mt-4"
                          >
                            {slide.button.title}
                          </a>
                        )}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )
        )}
      </div>
    </div>
  );
};

export default DiagnosisTests;
